import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@material-ui/core';
import { getCustomerGiftCardsBalanceApi } from 'api';
import { TextFormattedNumber } from 'components';
import CustomerGiftCardsTable from './CustomerGiftCardsTable';


const CustomerGiftCards = ({customerId}) => {
  const dispatch = useDispatch();

  const {
    giftCardsBalance
  } = useSelector((state: IReduxState) => state.customers);

  useEffect(() => {
    getCustomerGiftCardsBalanceApi({dispatch, customerId});
  }, [customerId]);

  return (
    <>
      <div className="flex justify-end mb-5">
        <div className="px-10 py-5 w-full max-w-300 text-center border-radius-8 bg-light-primary elevation-z8">
          {'Gift Card Credit Balance: '}
          <TextFormattedNumber
            value={giftCardsBalance}
            prefix="$"
          />
        </div>
      </div>
      <Card elevation={20}>
        <CustomerGiftCardsTable customerId={customerId} />
      </Card>
    </>
  );
};

export default CustomerGiftCards;
